import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AnimaltypesService } from 'src/app/services/animaltypes.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-animaltypes',
  templateUrl: './animaltypes.component.html',
  styleUrls: ['./animaltypes.component.scss']
})
export class AnimaltypesComponent implements OnInit {
  public loadedAnimals:boolean=false;
  public categories:any[];
  public paginatedAnimalTypes = new BehaviorSubject<any>(null);
  private perPage=20;
  public showAdd:boolean=false;
  public newAnimal:string='';

  constructor(
    private _animaltypes:AnimaltypesService,
    private _notify: MatSnackBar
  ) { }

  public notify(message:string, action:string) {
    this._notify.open(message, action, {
      duration: 4000,
      verticalPosition: 'top'
    });
  }

  public getanimalTypes(page){
    this._animaltypes.getPaginatedAnimalTypes(page, this.perPage).subscribe(paginatedData => {
      this.paginatedAnimalTypes.next(paginatedData);
      this.loadedAnimals=true;
    });
  }

  public addAnimalType(){
    this.showAdd=!this.showAdd;
  }

  saveNewAnimal(){
    if(!confirm('Add this new animal type?')) return;
    this._animaltypes.addAnimalType(this.newAnimal).subscribe(
      res=>{
        if(res.message) {
          this.notify(res.message, 'OK');
        } else {
          this.getanimalTypes(1);
          this.cancelNewAnimal();
        }
      }
    );
  }

  cancelNewAnimal(){
    this.newAnimal='';
    this.showAdd=false;
  }

  pageChanged(data){
    this.perPage=data.pageSize;
    this.getanimalTypes(data.pageIndex+1);
  }

  perPageChanged(data){
    this.perPage=data.pageSize;
    this.getanimalTypes(1);
  }

  ngOnInit() {
    this.getanimalTypes(1);
  }

}
